import React from 'react';
import { ExternalLink } from "react-feather";
import Item from "components/LM/Voice/Item";

function Url(props) {
	const { url, type, onToggle, checked, ...otherProps } = props;

	let error;
	if (url.error) {
		error = <p className="mb-0 text-danger">
			<em>Error: {url.error}</em>
		</p>
	}

	return (
		<Item
			id={`url_${type}_${url.id}`}
			className={`item url_${type}`}
			type={type}
			checked={checked}
			onToggleItem={onToggle}
			addedAt={url.added_at}
			{...otherProps}>
			<span className='text-ellipsis-title'>{url.url}</span>
			<a href={url.url} target='_blank' className='external-link ' rel='noopener noreferrer'><ExternalLink className="feather align-middle icon" /></a>
			<p className="details type text-black-50 mb-0">{type === 'instagram' ? <span className="font-weight-bold">This profile is stored as a link.</span> : <span className="text-capitalize">{url.type}</span>}</p>
			{error}
		</Item>

	)
}

export default Url;
